module.exports = __webpack_public_path__ + "82215085cafdff3771b9e81a99f0c650.png";